import { render, staticRenderFns } from "./produtos.vue?vue&type=template&id=2eb9f7cd"
import script from "./produtos.ts?vue&type=script&lang=js&external"
export * from "./produtos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb9f7cd')) {
      api.createRecord('2eb9f7cd', component.options)
    } else {
      api.reload('2eb9f7cd', component.options)
    }
    module.hot.accept("./produtos.vue?vue&type=template&id=2eb9f7cd", function () {
      api.rerender('2eb9f7cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/fastaction/produtos/produtos.vue"
export default component.exports